// ============================================================================
// i18n Core - Types and helpers for internationalization
// ============================================================================
export { en } from './en.js';
export * from './translations.js';
// Interpolation: replaces {key} with value from params
// Example: interpolate("Hello {name}", { name: "World" }) => "Hello World"
export const interpolate = ({ text, params, }) => {
    return text.replace(/\{(\w+)\}/g, (_, key) => {
        const value = params[key];
        return value !== undefined ? String(value) : `{${key}}`;
    });
};
// Get nested value from object using dot notation
// Example: getNestedValue(obj, "ui.panels.build") => obj.ui.panels.build
export const getNestedValue = ({ obj, path, }) => {
    const keys = path.split('.');
    let current = obj;
    for (const key of keys) {
        if (current === null || current === undefined || typeof current !== 'object') {
            return undefined;
        }
        current = current[key];
    }
    return typeof current === 'string' ? current : undefined;
};
// Convert SCREAMING_SNAKE_CASE to camelCase for translation keys
// Example: "IRON_ORE" => "ironOre"
export const toTranslationKey = ({ enumKey }) => {
    return enumKey.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};
//# sourceMappingURL=index.js.map